export default "__VITE_ASSET__7c8dbe89__"